<template>
  <div class="page-template">
      <div class="page-title">{{ title }}</div>
        <search-form-template
      ref="storeTemplate"
      :searchOptions="storeSearchOptions"
      @searchSubmit="searchSubmit"
      @clear="clearSearch"
      @btnCommon="btnCommon"
    ></search-form-template>
      <div class="goods-data">
           <div class="goods-data-data" v-for="(v,i) in datalist" :key="i">
            <div :style="{color:v.color}">0</div>
            <span>{{ v.data }}</span>
          </div>
      </div>
      <div class="echarbox">
        <div class="chartsbox-list">
          <span>报损状况</span>
          <div class="data-range">
             <search-form-template
               :searchOptions="lossSearchOptions"
                ref="lossTemplate"
                @searchSubmit="losssearchSubmit"
                @clear="lossclearSearch"
                @btnCommon="lossbtnCommon"
            ></search-form-template>
          </div>
          <div class="echartsArea1">
                <echarts-template class="charts-line" ref="lossEcharts" :picOption="lossEcharts"></echarts-template>
          </div>
        </div>
         <div class="chartsbox-list">
          <span>库存变动</span>
           <div class="data-range">
             <search-form-template
               :searchOptions="InventorySearchOptions"
               @searchSubmit="inventorysearchSubmit"
               @clear="clearSearch"
              @btnCommon="inventorybtnCommon"
            ></search-form-template>
          </div>
          <div class="echartsArea1">
                <echarts-template class="charts-line" ref="InventoryEcharts" :picOption="InventoryEcharts"></echarts-template>
          </div>
        </div>
         <div class="chartsbox-list">
          <span>商品分类消费排名</span>
          <div>
          <search-form-template
            :searchOptions="gcategorySearchOptions"
            @searchSubmit="gcategorysearchSubmit"
            @clear="clearSearch"
          @btnCommon="gcategorybtnCommon"
        ></search-form-template> 
        <el-tabs v-model="activeTab">
      <el-tab-pane label="销量" name="saleNumber" >
         <div class="centerBack3">
             <div class="echartsArea3">
                <echarts-template class="charts-box" ref="gcategorySaleEcharts" 
                            :picOption="gcategorySaleEcharts">
                </echarts-template>
             </div>
             <div class="threeTable">
                  <table-template ref="categorySaleNumber"
                    :tableOptions="categorySaleNumberTable" >
                   </table-template>
             </div>
          </div>
      </el-tab-pane>

      <el-tab-pane label="金额" name="casher">
        <div class="centerBack3">
             <div class="echartsArea3">
               <echarts-template class="charts-box-casher" ref="gcategoryCashEcharts" 
                            :picOption="gcategoryCashEcharts">
                </echarts-template>
             </div>
            <div class="threeTable">
              <table-template ref="categoryCasher"
                          :tableOptions="categoryCasherTable"
              ></table-template>
           </div>
        </div>
      </el-tab-pane>
    </el-tabs>
          </div>
        </div>
         <div class="chartsbox-list">
          <span>普通商品销售排名</span>
          <div>
            <search-form-template
               :searchOptions="generalSearchOptions"
               @searchSubmit="generalsearchSubmit"
               @clear="clearSearch"
              @btnCommon="generalbtnCommon"
            ></search-form-template> 
            <el-tabs v-model="goodsTab">
      <el-tab-pane label="销量" name="saleNumber" >
         <div class="centerBack3">
             <div class="echartsArea3">
                <echarts-template class="charts-box" ref="generalSaleEcharts" 
                            :picOption="generalSaleEcharts">
                </echarts-template>
             </div>
             <div class="threeTable">
                  <table-template ref="generalGoods"
                    :tableOptions="generalGoodsTable" >
                   </table-template>
             </div>
       
          </div>
      </el-tab-pane>

      <el-tab-pane label="金额" name="casher">
        <div class="centerBack3">
             <div class="echartsArea3">
               <echarts-template  class="charts-box-casher" ref="generalCashEcharts" 
                         :picOption="generalCashEcharts">
               </echarts-template>
             </div>
            <div class="threeTable">
              <table-template ref="generalCasher"
                          :tableOptions="generalCasherTable"
              ></table-template>
           </div>
        </div>
      </el-tab-pane>
    </el-tabs>
          </div>
        </div>
         <div class="chartsbox-list">
          <span>商品警惕</span>
          <div>
           <el-tabs v-model="vigilanceTab">
      <el-tab-pane label="销量下跌" name="salesFell" >
        <div class="infoquestion"><i class="el-icon-info"></i>&nbsp;&nbsp;销量下跌是指最近7天销量较上一个周期7天销售量下跌的商品</div>
         <div class="centerBack3">
             <div class="fiveTable">
                  <table-template ref="salesFell"
                    :tableOptions="salesFellTable" >
                   </table-template>
             </div>
          </div>
      </el-tab-pane>
      <el-tab-pane label="滞销商品" name="unsalableGoods">
         <div class="infoquestion"><i class="el-icon-info"></i>&nbsp;&nbsp;滞销商品是指最近3个月有销量，但近7天没有产生任何销量的商品</div>
        <div class="centerBack3">
            <div class="fiveTable">
              <table-template ref="unsalableGoods"
                          :tableOptions="unsalableGoodsTable"
              ></table-template>
           </div>
        </div>
      </el-tab-pane>
    </el-tabs>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import echartsTemplate from "@/components/controls/echarts";
import {gcategorySaleEcharts,gcategoryCashEcharts,generalSaleEcharts,generalCashEcharts,lossEcharts,InventoryEcharts} from '@/page/home/options/reportEcharts'
import api from "@/config/api";
import tableTemplate from '@/components/template/tableTemplate';
import searchFormTemplate from '@/components/template/searchFormTemplate';
import userPower from "@/mixin/userPower";
export default {
    mixins: [userPower],
    components: {searchFormTemplate,tableTemplate,echartsTemplate},
   data(){
      let stCreateDttm = this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
      let edCreateDttm = this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
      let defaultParam = {dateType:20,stCreateDttm: stCreateDttm, edCreateDttm: edCreateDttm};
       return {
           dateType:'',
           goodsParam:'',
           param: defaultParam,
           lossEcharts,
           InventoryEcharts,
           gcategorySaleEcharts,
           gcategoryCashEcharts,
           generalSaleEcharts,
           generalCashEcharts,
           activeTab: 'saleNumber',
           goodsTab:'saleNumber',
           vigilanceTab:"salesFell",
           title:"",
              storeSearchOptions: {
          simple: [
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              data: [],
              span: 24
            },
          ],
        },
        generalSearchOptions:{
          simple: [
            {
              label: '',
              prop: 'CreateDttm',
              type: 'datetimeRange',
              dateType:"datetime",
              span: 24
            },
                ],
        },
        gcategorySearchOptions:{
            simple: [
            {
              label: '',
              prop: 'CreateDttm',
              type: 'datetimeRange',
              dateType:"datetime",
              span: 24
            },
                ],
        },
           datalist: [
                {data: "商品数量(种)", color: "#5f58e6"},
                {data: "商品库存(件)", color: "#5f58e6"},
            ],
          //报损状况
            lossSearchOptions:{
             simple: [
            {
              label: '',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType:"datetime",
              rangeButton:[{label:'今天',value:1},{label:'昨天',value:2},{label:'本周',value:4},{label:'本月',value:6}],
              span: 24
            },
                ],
            },
            //库存变动
            InventorySearchOptions:{
                simple: [
            {
              label: '',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: "datetime",
              rangeButton:[{label:'今天',value:1},{label:'昨天',value:2},{label:'本周',value:4},{label:'本月',value:6}],
              span: 24
            },
                ]
            },
          //商品分类销售排名
            categorySaleNumberTable:{
              indexShow: false,//是否显示索引
            columns: [
            {
                label: '商品分类',
                prop: 'goodsCategoryName',
                width: '85',
                align: 'center'
            },
            {
                label: '销量',
                prop: 'goodsNum',
                width: '65',
                align: 'center'
            },
            {
                label: '占比',
                prop: 'goodsNumRate',
                width: '60',
                align: 'center'
            },
            {
                label: '同比',
                prop: 'sameGoodsNum',
                width: '60',
                align: 'center'
            },
             {
                label: '环比',
                prop: 'surroundGoodsNum',
                width: '60',
                align: 'center'
            },
            ],
             param:{type:10},
            url: api.report.mcategoryGoods
      },
           categoryCasherTable:{
            indexShow: false,//是否显示索引
            columns: [
            {
                label: '商品分类',
                prop: 'goodsCategoryName',
                width: '85',
                align: 'center'
            },
            {
                label: '金额',
                prop: 'payPrice',
                width: '65',
                align: 'center'
            },
            {
                label: '占比',
                prop: 'payPriceRate',
                width: '60',
                align: 'center'
            },
            {
                label: '同比',
                prop: 'samePayPrice',
                width: '60',
                align: 'center'
            },
             {
                label: '环比',
                prop: 'surroundPayPrice',
                width: '60',
                align: 'center'
            },
            ],
            param:{type:20},
            url: api.report.mcategoryGoods
      },
         //普通商品销售排名
         generalGoodsTable:{
            indexShow: false,//是否显示索引
            columns: [
            {
                label: '商品名称',
                prop: 'goodsName',
                width: '85',
                align: 'center'
            },
            {
                label: '销量',
                prop: 'goodsNum',
                width: '65',
                align: 'center'
            },
            {
                label: '占比',
                prop: 'goodsNumRate',
                width: '60',
                align: 'center'
            },
            {
                label: '同比',
                prop: 'sameGoodsNum',
                width: '60',
                align: 'center'
            },
             {
                label: '环比',
                prop: 'surroundGoodsNum',
                width: '60',
                align: 'center'
            },
            ],
            param:{type:10},
            url: api.report.generalGoods
         },
         generalCasherTable:{
           indexShow: false,//是否显示索引
            columns: [
            {
                label: '商品名称',
                prop: 'goodsName',
                width: '85',
                align: 'center'
            },
            {
                label: '金额',
                prop: 'payPrice',
                width: '65',
                align: 'center'
            },
            {
                label: '占比',
                prop: 'goodsNumRate',
                width: '60',
                align: 'center'
            },
            {
                label: '同比',
                prop: 'samePayPrice',
                width: '60',
                align: 'center'
            },
             {
                label: '环比',
                prop: 'surroundPayPrice',
                width: '60',
                align: 'center'
            },
            ],
            param:{type:20},
            url: api.report.generalGoods
         },
         //商品警惕
         salesFellTable:{
            indexShow: false,//是否显示索引
            columns: [
            {
                label: '商品名称',
                prop: 'goodsName',
                width: '80',
                align: 'center'
            },
            {
                label: '上周期7天销量',
                prop: 'lastGoodsNum',
                width: '80',
                align: 'center'
            },
            {
                label: '最近7天销量',
                prop: 'goodsNum',
                width: '80',
                align: 'center'
            },
            {
                label: '下跌比例',
                prop: 'goodsNumRate',
                width: '80',
                align: 'center'
            },
            ],
            url: api.report.saleFellTable
         },
         unsalableGoodsTable:{
             indexShow: false,//是否显示索引
            columns: [
            {
                label: '商品名称',
                prop: 'goodsName',
                width: '70',
                align: 'center'
            },
             {
                label: '上周期7天销量',
                prop: 'lastGoodsNum',
                width: '50',
                align: 'center'
            },
            {
                label: '最近7天销量',
                prop: 'goodsNum',
                width: '50',
                align: 'center'
            },
            ],
            url: api.report.unsaleTable
         }
       }
   },
   created(){
      this.setStore(this.storeSearchOptions.simple);
      this.allStore(),
      this.getGoodsDetail(this.result),
      this.getLossEcharts(this.param),
      this.getInventory(this.param),
      this.getCategorySaleEcharts(this.param),
      this.getCategoryCashEcharts(this.param),
      this.getGeneralSaleEcharts(this.param),
      this.getGeneralCashEcharts(this.param)
   },
   methods:{
      allStore(){
          let mes=[]
          mes.unshift({name:"全部门店",value:""});
          this.$axios.fetchPost(api.system.seStore+'/list').then(data=>{
            if(data.code===200){
            data.data.unshift({name:"全部门店",value:""});
            this.storeSearchOptions.simple.filter(item=>item.prop==="storeId")[0].data=data.data;
          }
          })
       },
     //商品概览
      getGoodsDetail(param){
           this.$axios.fetchPost(api.report.getGoodsDetail,param).then(data=>{
             if(data.code==200){
               let goodsdatabox = document.querySelectorAll(".goods-data-data div");
               for (let i = 0; i < goodsdatabox.length; i++) {
                  goodsdatabox[0].innerHTML = data.data.goodsCount;
                  goodsdatabox[1].innerHTML = data.data.inventoryNum;
                }
             }
           })
      },
     //商品销售分类排名
      getCategorySaleEcharts(param){
          let params=Object.assign({},{type:10,pageNumber:1,pageSize:10},param)
               this.$axios.fetchPost(api.report.mcategoryGoods+'/page',params).then(data => {
              if (data.code == 200) {
                  let cateGoryEchart=data.data.records.slice(0,5)
                if(cateGoryEchart.length==0){
                    this.gcategorySaleEcharts.charsOption.title.text = "暂未查询到相关记录";
                    this.gcategorySaleEcharts.charsOption.title.top='center'
                    this.gcategorySaleEcharts.charsOption.title.left='center'
                    this.gcategorySaleEcharts.charsOption.series[0].data=[{}]
                }else{
                    this.gcategorySaleEcharts.charsOption.title.text ="";
                    this.gcategorySaleEcharts.charsOption.title.top=0
                    this.gcategorySaleEcharts.charsOption.title.left=0
                    this.gcategorySaleEcharts.charsOption.series[0].data = [];
                  cateGoryEchart.map(item => {
                  this.gcategorySaleEcharts.charsOption.series[0].data.push({value: item.goodsNum, name: item.goodsCategoryName})
                  // this.gcategorySaleEcharts.charsOption.legend.data.push(item.payName)
                  if(cateGoryEchart.goodsCategoryName=null){
                      this.gcategorySaleEcharts.charsOption.series[0].data=[]
                  }
                   })
                }
                this.$nextTick(() => {
                  this.$refs.gcategorySaleEcharts.drawpic();
                });
              }
            }).catch(err => {
              this.$message({message: '请求失败！', type: 'error'})
            })
        },
      getCategoryCashEcharts(param){
           let params=Object.assign({},{type:20,pageNumber:1,pageSize:10},param)
           this.$axios.fetchPost(api.report.mcategoryGoods+'/page',params).then(data => {
              if (data.code == 200) {
                  let catcashEcharts=data.data.records.slice(0,5)
                  if(catcashEcharts.length===0){
                    this.gcategoryCashEcharts.charsOption.title.text = "暂未查询到相关记录";
                    this.gcategoryCashEcharts.charsOption.title.top='center'
                    this.gcategoryCashEcharts.charsOption.title.left='center'
                    this.gcategoryCashEcharts.charsOption.series[0].data=[{}]
                  }else{
                      this.gcategoryCashEcharts.charsOption.title.text ="";
                      this.gcategoryCashEcharts.charsOption.title.top=0
                      this.gcategoryCashEcharts.charsOption.title.left=0
                      this.gcategoryCashEcharts.charsOption.series[0].data = [];
                     catcashEcharts.map(item => {
                         this.gcategoryCashEcharts.charsOption.series[0].data.push({value: item.payPrice, name: item.goodsCategoryName})
                  // this.gcategorySaleEcharts.charsOption.legend.data.push(item.payName)
                  if(catcashEcharts.payPrice=null){
                      this.gcategoryCashEcharts.charsOption.series[0].data=[]
                  }
                })
                  }
                this.$nextTick(() => {
                  this.$refs.gcategoryCashEcharts.drawpic();
                });
              }
            }).catch(err => {
              this.$message({message: '请求失败！', type: 'error'})
            })
        },
        //普通商品销售排名
      getGeneralSaleEcharts(param){
           let params=Object.assign({},{type:10,pageNumber:1,pageSize:10},param)
            this.$axios.fetchPost(api.report.generalGoods+'/page',params).then(data => {
              if (data.code == 200) {
               let catcashEcharts=data.data.records.slice(0,5)
                 if(catcashEcharts.length==0){
                    this.generalSaleEcharts.charsOption.title.text = "暂未查询到相关记录";
                    this.generalSaleEcharts.charsOption.title.top='center'
                    this.generalSaleEcharts.charsOption.title.left='center'
                    this.generalSaleEcharts.charsOption.series[0].data=[{}]
               }else{
                  this.generalSaleEcharts.charsOption.title.text ="";
                  this.generalSaleEcharts.charsOption.title.top=0
                  this.generalSaleEcharts.charsOption.title.left=0
                  this.generalSaleEcharts.charsOption.series[0].data = [];
                     catcashEcharts.map(item => {
                  this.generalSaleEcharts.charsOption.series[0].data.push({value: item.goodsNum, name: item.goodsName})
                  // this.gcategorySaleEcharts.charsOption.legend.data.push(item.payName)
                  if(catcashEcharts.goodsNum=null){
                      this.generalSaleEcharts.charsOption.series[0].data=[]
                  }
                })
               }
                
                this.$nextTick(() => {
                  this.$refs.generalSaleEcharts.drawpic();
                });
              }
            }).catch(err => {
              this.$message({message: '请求失败！', type: 'error'})
            })
        },
      getGeneralCashEcharts(param){
           let params=Object.assign({},{type:20,pageNumber:1,pageSize:10},param)
            this.$axios.fetchPost(api.report.generalGoods+'/page',params).then(data => {
              if (data.code == 200) {
               let catcashEcharts=data.data.records.slice(0,5)
               if(catcashEcharts.length==0){
                    this.generalCashEcharts.charsOption.title.text = "暂未查询到相关记录";
                    this.generalCashEcharts.charsOption.title.top='center'
                    this.generalCashEcharts.charsOption.title.left='center'
                    this.generalCashEcharts.charsOption.series[0].data=[{}]
               }else{
                  this.generalCashEcharts.charsOption.title.text ="";
                  this.generalCashEcharts.charsOption.title.top=0
                  this.generalCashEcharts.charsOption.title.left=0
                  this.generalCashEcharts.charsOption.series[0].data = [];
                catcashEcharts.map(item => {
                  this.generalCashEcharts.charsOption.series[0].data.push({value: item.payPrice, name: item.goodsName})
                  // this.gcategorySaleEcharts.charsOption.legend.data.push(item.payName)
                  if(catcashEcharts.payPrice=null){
                      this.generalCashEcharts.charsOption.series[0].data=[]
                  }
                })
               }
                this.$nextTick(() => {
                  this.$refs.generalCashEcharts.drawpic();
                });
              }
            }).catch(err => {
              this.$message({message: '请求失败！', type: 'error'})
            })
        },
        //报损状况
      getLossEcharts(param){
         let $param=Object.assign({},param,{dateType:this.dateType||10})
            this.$axios.fetchPost(api.report.lossEacharts,$param).then(data => {
          if (data.code == 200) {
            this.lossEcharts.charsOption.xAxis.data = data.data.dateTime;
            this.lossEcharts.charsOption.series[0].data = data.data.goodsNum;
            this.$nextTick(() => {
                this.$refs.lossEcharts.drawpic();
              });
            }
          }).catch(err => {
        this.$message({message: '请求失败！', type: 'error'})
          })
        
        },
        //库存变动
      getInventory(param){
          let params=Object.assign({},this.goodsParam,param)
           this.$axios.fetchPost(api.report.intenvoryChange,params).then(data => {
          if (data.code == 200) {
            this.InventoryEcharts.charsOption.xAxis[0].data = data.data.modeName;
            this.InventoryEcharts.charsOption.series[0].data = data.data.goodsCategoryNum;
            this.$nextTick(() => {
                this.$refs.InventoryEcharts.drawpic();
              });
            }
          }).catch(err => {
        this.$message({message: '请求失败！', type: 'error'})
          })
        },
      losssearchSubmit(param) {
        let dateType=this.$refs["lossTemplate"].$refs["CreateDttm"][0].dateTypeActive
          if(dateType==1||dateType==2){
              this.dateType = 10
          }
          if(dateType==4||dateType==6){
              this.dateType =20
          }
          let lossParams = Object.assign({}, this.goodsParam,this.param, param);
          this.getLossEcharts(lossParams)
        },
      searchSubmit (result) {
        this.goodsParam= result
        let params = Object.assign({},this.goodsParam,this.param)
        this.$refs["salesFell"].searchSubmit(result)
        this.$refs["unsalableGoods"].searchSubmit(result)
        this.getInventory(params)
        this.getGoodsDetail(result)
        this.getLossEcharts(params)
        this.getCategorySaleEcharts(params)
        this.getCategoryCashEcharts(params)
        this.getGeneralSaleEcharts(params)
        this.getGeneralCashEcharts(params)
        this.$refs["categorySaleNumber"].searchSubmit(params)
        this.$refs["categoryCasher"].searchSubmit(params)
        this.$refs["generalGoods"].searchSubmit(params)
        this.$refs["generalCasher"].searchSubmit(params)
      },
      //商品分类消费排名查询
      gcategorysearchSubmit(result){
          this.getCategorySaleEcharts(result),
          this.getCategoryCashEcharts(result),
          this.$refs["categorySaleNumber"].searchSubmit(result)
          this.$refs["categoryCasher"].searchSubmit(result)
      },
      //普通商品销售排名查询
      generalsearchSubmit(result){
        console.log(result)
        this.getGeneralSaleEcharts(result),
        this.getGeneralCashEcharts(result),
        this.$refs["generalGoods"].searchSubmit(result)
        this.$refs["generalCasher"].searchSubmit(result)
      },
      clearSearch () {
        
        },
      btnCommon(btnObj) {
            btnObj.callback && btnObj.callback();
          },
      lossclearSearch() {
            this.getLossEcharts(this.param)
          },
      lossbtnCommon(btnObj) {
            btnObj.callback && btnObj.callback();
          },
      generalbtnCommon(btnObj){
          btnObj.callback && btnObj.callback();
        },
      inventorysearchSubmit(result){
            this.getInventory(result)
          },
      inventorybtnCommon(btnObj) {
            btnObj.callback && btnObj.callback();
          },
      gcategorybtnCommon(btnObj){
             btnObj.callback && btnObj.callback();
          }
        },
     mounted(){
        this.$refs["categorySaleNumber"].searchSubmit(this.param)
        this.$refs["categoryCasher"].searchSubmit(this.param)
        this.$refs["generalGoods"].searchSubmit(this.param)
        this.$refs["generalCasher"].searchSubmit(this.param)
        this.title = document.title;

     },
}
</script>

<style scoped>
.goods-data{
    height: 100px;
    display: flex;
    width:45%;
    justify-content: space-between;
    margin-bottom: 20px;
}
.goods-data .goods-data-data{
    background: #fff;
    width:48%;
    border-radius: 14px;
    padding: 15px;
    box-shadow: 3px 3px 3px #e1e1e1;
    height: 111px;
}
.goods-data .goods-data-data>div{
    font-size: 28px;
    margin-bottom: 10px;
}
.echarbox{
    display: flex;
    flex: 2;
    flex-wrap: wrap;
    justify-content: space-between;
}
.echarbox .chartsbox-list{
    width: 49%;
    background: #fff;
    border-radius: 8px;
    box-shadow: 3px 3px 3px #e5e5e5;
    margin-bottom: 10px;
    border: 1px solid #e5e5e5;
}
.echarbox .chartsbox-list>span{
    background: #f2f2f2;
    display: block;
    padding: 8px;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    color: #333;
    font-weight: bold;
}
.echarbox .chartsbox-list>div{
    background: #fff;
    padding: 12px;
}
.centerBack3{
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.echartsArea3{
    width: 38%;
    min-height: 270px;
}
.threeTable{
  width: 59%;
}
>>>.pagination-box{
  overflow: auto;
}
.fiveTable{
  width: 100%;
}
.echartsArea3 .charts-box-casher{
  height: 270px;
  width: calc(20vw - 53px);
}
.echartsArea1 .charts-line{
  height: 180px;
}
>>>.search-item{
  display: flex;
}
>>>.el-icon-search,>>>.el-icon-refresh{
    line-height: unset;
}
.threeTable >>>.el-table__body-wrapper{
  max-height: 170px;
  overflow-y: auto;
}
.fiveTable >>>.el-table__body-wrapper{
  max-height: 170px;
  overflow-y: auto;
  overflow-x:hidden ;
}
.infoquestion{
  font-size: 14px;
  margin-bottom: 10px;
  color: #c9c9c9;
  margin-left: 5px;
}

</style>


// WEBPACK FOOTER //
// src/page/report/inventory/Preview.vue